import i18n from "../i18n";

const errorsKeyPattern = /^errors\.(.+)$/;

/**
 * Returns a user-facing error message for API errors.
 * Priority:
 *   1. error.key           → translate via common:errors.{key}
 *   2. error.message matching "errors.KEY" pattern → extract key, translate
 *   3. error.message as-is (already human-readable)
 *   4. default fallback
 * @param {{ message?: string, key?: string }} error
 * @returns {string}
 */
export default function getErrorMessage(error) {
  if (!error) return i18n.t("common:errors.default");

  const key = error.key || (errorsKeyPattern.exec(error.message) || [])[1];
  if (key) {
    return i18n.t(`common:errors.${key}`, {
      defaultValue: i18n.t("common:errors.default"),
    });
  }

  return error.message || i18n.t("common:errors.default");
}
